import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Video, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface VideoAssignment {
  id: string;
  video_title: string;
  assigned_by_name: string;
  notes?: string;
  due_date?: string;
}

interface VideoAssignmentsWidgetProps {
  assignments: VideoAssignment[];
  loading?: boolean;
}

export function VideoAssignmentsWidget({ assignments, loading }: VideoAssignmentsWidgetProps) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Video className="h-5 w-5" />
            Video Assignments
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Video className="h-5 w-5" />
          Video Assignments ({assignments.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {assignments.length === 0 ? (
          <p className="text-sm text-muted-foreground">No pending assignments</p>
        ) : (
          <div className="space-y-3">
            {assignments.slice(0, 3).map((assignment) => (
              <div key={assignment.id} className="flex items-start justify-between border-b pb-2 last:border-0">
                <div className="flex-1">
                  <p className="font-medium text-sm">{assignment.video_title}</p>
                  <p className="text-xs text-muted-foreground">From: {assignment.assigned_by_name}</p>
                  {assignment.due_date && (
                    <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1">
                      <Clock className="h-3 w-3" />
                      Due: {new Date(assignment.due_date).toLocaleDateString()}
                    </p>
                  )}
                </div>
              </div>
            ))}
            {assignments.length > 3 && (
              <Button 
                variant="link" 
                size="sm" 
                className="w-full"
                onClick={() => navigate('/video-assignments')}
              >
                View all {assignments.length} assignments
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
